import React from 'react';

const FormCheckbox = ({ label, checked, onChange, helperText }) => {
  return (
    <div>
      <label className="flex items-start cursor-pointer">
        <input
          type="checkbox"
          checked={checked || false}
          onChange={(e) => onChange(e.target.checked)}
          className="w-5 h-5 text-blue-600 focus:ring-2 focus:ring-blue-500 rounded mt-0.5"
        />
        <span className="ml-3 text-sm text-gray-700">{label}</span>
      </label>
      {helperText && (
        <p className="text-xs text-gray-500 ml-8 mt-1">{helperText}</p>
      )}
    </div>
  );
};

export default FormCheckbox;